import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas font-sans text-ink" data-id="element-0" data-mp="3ikr0e3urxc7u">
      <MetaPixel data-id="element-1" data-mp="3ml1397n9rmih" />
      <Hero data-id="element-2" data-mp="3mkhn9wh6j873" />
      <main data-id="element-3" data-mp="3mk83wrqn3zad">
        <Story data-id="element-4" data-mp="3mjq2zht18ww4" />
        <BeforeAfter data-id="element-5" data-mp="3mj6hjr46bqdc" />
        <PainPoints data-id="element-6" data-mp="3rcj8i7wbs999" />
        <Volumes data-id="element-7" data-mp="3rbzpsoyupgu6" />
        <Tools data-id="element-8" data-mp="3rdkkqfp2v1sk" />
        <Bonuses data-id="element-9" data-mp="3rd18nfm3z7mg" />
        <Offer data-id="element-10" data-mp="3relvsk63foaa" />
        <Guarantee data-id="element-11" data-mp="5orh0l86u6j" />
        <Testimonials data-id="element-12" data-mp="680frswe88f" />
        <Author data-id="element-13" data-mp="5gfrc0u9uwx" />
        <Faq data-id="element-14" data-mp="82ld64660ci" />
        <FinalCta data-id="element-15" data-mp="7stte3h7l4p" />
      </main>
      <Footer data-id="element-16" data-mp="2zlv6ktmtuzuj" />
      <FloatingCta data-id="element-17" data-mp="2zm4xqkjlzd1t" />
      <PurchasePopup data-id="element-18" data-mp="2zmo89g6xiz5t" />
    </div>;
}